import {Component, Input, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";

@Component({
  selector: 'my-menu',
  template: require('./menu.component.html'),
  styles: [require('./menu.component.scss')]
})
export class MenuComponent implements OnInit  {

  @Input() data: any;
  appFuncs: any;

  constructor(private app: AppComponent) {
    this.appFuncs = this.app;
  }

  ngOnInit() {}



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/menu/menu.component.ts